import { render } from "./NotificationsPanel.vue?vue&type=template&id=22805d00"
import script from "./NotificationsPanel.vue?vue&type=script&lang=js"
export * from "./NotificationsPanel.vue?vue&type=script&lang=js"

import "./NotificationsPanel.vue?vue&type=style&index=0&id=22805d00&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__